// extracted by mini-css-extract-plugin
export default {"container":"nHlGxO","column":"lPd12K","row":"TGmErQ"};